import { query } from 'atomic-layout';
import styled from 'styled-components';

import { ColorTypes, ColorValues } from '@/types/styles';

export const DEFAULT_MAX_WIDTH = 1280;
export const DEFAULT_PADDING = 24;
export const DEFAULT_COLOR_TYPE = 'display';
export const DEFAULT_COLOR_VALUE = '0';

interface IMaxWidth {
  padding?: number;
  maxWidth?: number;
  colorType?: ColorTypes;
  colorValue?: ColorValues;
  backgroundBorderRadius?: string;
  backgroundBorderRadiusSmall?: string;
}

export const MaxWidth = styled.div<IMaxWidth>`
  width: 100%;
  margin: 0 auto;
  position: relative;
  max-width: ${({ maxWidth = DEFAULT_MAX_WIDTH, padding = DEFAULT_PADDING }) =>
    maxWidth + padding * 2}px;

  ::before {
    top: 0;
    z-index: -1;
    content: '';
    width: 100vw;
    height: 100%;
    position: absolute;
    left: calc((98.9% - 100vw) / 2);
    border-radius: ${({ backgroundBorderRadius }) =>
      backgroundBorderRadius || 0};
    background-color: ${({
      theme,
      colorType = DEFAULT_COLOR_TYPE,
      colorValue = DEFAULT_COLOR_VALUE,
    }) => theme.colors[colorType][colorValue]};
  }

  @media ${query({ to: 'xl' })} {
    ::before {
      left: calc((100% - 100vw) / 2);
    }
  }

  @media ${query({ to: 'sm' })} {
    ::before {
      border-radius: ${({ backgroundBorderRadiusSmall }) =>
        backgroundBorderRadiusSmall || 0};
    }
  }
`;
